<template>
    <div class="modal fade inactivity" tabindex="-1" :id="modalId" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content text-center">
                <div class="modal-body p-4">
                    <p role="status">{{ message }}</p>
                    <ColoredButton class="w-auto btn--yes" @click="confirm">Yes</ColoredButton>
                    <button type="button" class="btn btn--white border-green w-auto btn--no" @click="deny">No</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ColoredButton from './ColoredButton';
    export default {
        components: {
            ColoredButton
        },
        props: {
            modalId: {
                type: String,
                required: true
            },
            triggerEventName: {
                type: String,
                required: true
            },
        },
        data() {
            return {
                message : null,
                confirmCallback : null,
                denyCallback : null,
                showModal : false
            }
        },
        watch : {
            showModal : function(){
                var hashModalId = "#"+this.modalId;
                if(this.showModal){
                    $(hashModalId).modalbs5({
                        show: true,
                        backdrop: 'static',
                        keyboard: false
                    })
                }
                else{
                    $(hashModalId).modalbs5('hide');
                }
            }
        },
        methods: {
            confirm(){
                if(this.confirmCallback){
                    this.confirmCallback();
                }
                this.showModal = false;
            },
            deny(){
                if(this.denyCallback){
                    this.denyCallback();
                }
                this.showModal = false;
            }
            
        },
        mounted() {
            var self = this; // Have to use self to store the reference
            this.$parent.$on(this.triggerEventName, function(message, confirmCallback = null, denyCallback = null){
                self.message = message;
                self.confirmCallback = confirmCallback;
                self.denyCallback = denyCallback;
                self.showModal = true;
            })
        }
    }
</script>
